import ftApiClient from "./ftApiClient";

export const pointsApi = {
    upgradeToPointsAgent: (sharedByEmail?: string) => {
        const url = "/agent/integration/upgradeToAgent";
        const params = sharedByEmail ? { referrer: sharedByEmail } : undefined;
        return ftApiClient.post(url, {}, { params });
    },
    upgradeToCommissionAgent: (data: {
        bankBsb: string;
        bankAccount: string;
        bankCountryShortCode: string;
        businessNumber: string;
        tradingName: string;
    }) => {
        const url = "/integration/upgradeToCommissionAgent";
        return ftApiClient
            .post(url, data)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.error(
                    "[upgradeToCommissionAgent] Error:",
                    error.response?.data || error.message,
                );
                throw error;
            });
    },
    getPointsData: () => {
        const url = "/agent/integration/points";
        return ftApiClient.post(url).then((res) => {
            console.log("[DEBUG] GET POINTS DATA response:", JSON.stringify(res.data, null, 2));
            return res;
        });
    },

    getPointsHistory: (params: {
        startDate?: string;
        endDate?: string;
        untilTodayOnly: "1" | "0";
        onlyAvailablePoints: "1" | "0";
    }) => {
        const url = "/agent/integration/commissionReport";
        return ftApiClient.get(url, { params });
    },

    showHidePoints: () => {
        const url = "/user/points/show-hide";
        return ftApiClient.post(url);
    },
};
